/**
 * Feedback Question Registry
 *
 * To add or remove feedback questions, edit the FEEDBACK_QUESTIONS array below.
 * No component, backend, or database changes are needed -- the backend accepts
 * any string key in the granular_feedback JSONB column.
 *
 * Each question maps to one or more pipeline nodes for scoring/analytics.
 */

export interface FeedbackQuestion {
  key: string;
  label: string;
  visibleWhen: 'always' | 'hasVisualization' | 'hasSearchEnrichment';
  pipelineNodes: string[];
}

export const FEEDBACK_QUESTIONS: FeedbackQuestion[] = [
  {
    key: 'time_scope',
    label: 'Did the answer focus on the right time period?',
    visibleWhen: 'always',
    pipelineNodes: ['intent'],
  },
  {
    key: 'entity_recognition',
    label: 'Were the correct entities identified? (customers, regions, trades, corridors)',
    visibleWhen: 'always',
    pipelineNodes: ['intent', 'knowledge'],
  },
  {
    key: 'data_accuracy',
    label: 'Were the numbers and data retrieved correct and complete?',
    visibleWhen: 'always',
    pipelineNodes: ['knowledge', 'sql'],
  },
  {
    key: 'response_faithfulness',
    label: 'Was the response accurate with no fabricated or hallucinated information?',
    visibleWhen: 'always',
    pipelineNodes: ['response'],
  },
  {
    key: 'response_clarity',
    label: 'Was the answer clear, well-structured, and easy to follow?',
    visibleWhen: 'always',
    pipelineNodes: ['response'],
  },
  {
    key: 'visualization_quality',
    label: 'Were the charts clear, appropriate, and free of visual errors?',
    visibleWhen: 'hasVisualization',
    pipelineNodes: ['visualization'],
  },
  {
    key: 'external_insights',
    label: 'Were the external market insights relevant and useful?',
    visibleWhen: 'hasSearchEnrichment',
    pipelineNodes: ['search_enrichment'],
  },
];
